import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 2H2v20l4-4h16V2zM5 14l3.5-4.5 2.5 3.01L14.5 8l4.5 6H5z"
}), 'MmsSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/MmsSharp.js
// module id = 4854
// module chunks = 2